export interface TrendingItem {
  name: string;
  subtitle: string;
  imageUrl: string;
  linkUrl: string;
}

export const trendingItems: TrendingItem[] = [
  {
    name: 'Premium Sneakers',
    subtitle: 'Updated Weekly',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20running%20shoes%20in%20warm%20sand%20and%20olive%20tones%20on%20natural%20cork%20surface%2C%20soft%20morning%20light%2C%20modern%20athletic%20product%20photography%2C%20breathable%20mesh%20texture%20detail%20visible%2C%20contemporary%20minimalist%20aesthetic%2C%20clean%20composition%20with%20gentle%20shadows&width=400&height=400&seq=trending-v2-sneakers&orientation=squarish',
    linkUrl: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    name: 'Designer Knits',
    subtitle: 'New Arrivals',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oatmeal%20chunky%20knit%20sweater%20elegantly%20draped%20on%20raw%20linen%20fabric%2C%20soft%20window%20light%2C%20luxurious%20textile%20photography%2C%20visible%20yarn%20texture%20and%20intricate%20weave%20pattern%2C%20warm%20Scandinavian%20aesthetic%2C%20gentle%20shallow%20depth%20of%20field%2C%20refined%20editorial%20catalog%20style&width=400&height=400&seq=trending-v2-knits&orientation=squarish',
    linkUrl: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    name: 'Essential Tees',
    subtitle: 'Best Sellers',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20sage%20green%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20terrazzo%20surface%2C%20afternoon%20sunlight%2C%20clean%20minimalist%20product%20photography%2C%20visible%20soft%20knit%20texture%2C%20muted%20botanical%20color%20palette%2C%20simple%20refined%20composition%2C%20contemporary%20casual%20wear%20catalog&width=400&height=400&seq=trending-v2-tees&orientation=squarish',
    linkUrl: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    name: 'Artisan Bags',
    subtitle: 'Trending Now',
    imageUrl: 'https://readdy.ai/api/search-image?query=Handwoven%20raffia%20and%20leather%20crossbody%20bag%20on%20warm%20sandy%20beach%20wood%20surface%2C%20golden%20hour%20sunlight%2C%20artisanal%20craftsmanship%20product%20photography%2C%20natural%20material%20textures%20and%20intricate%20braiding%20detail%2C%20bohemian%20luxury%20aesthetic%2C%20gentle%20coastal%20ambiance&width=400&height=400&seq=trending-v2-bags&orientation=squarish',
    linkUrl: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
];